import { IntroJs } from "src/intro";
import refresh from "./refresh";

export default function onResize(intro: IntroJs) {
  refresh(intro);
}
